const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20avatar%2C%20casual%20style%2C%20warm%20lighting%2C%20natural%20expression%2C%20simple%20cream%20background%2C%20soft%20aesthetic%2C%20modern%20social%20media%20profile%20photo&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '15分钟前',
    content: '这个瓜也太劲爆了吧！刚看完视频，信息量太大了，我要缓缓...那个细节部分真的让人意想不到，建议大家都去看看原视频，绝对不亏！',
    likes: '3.2万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%2C%20trendy%20style%2C%20warm%20lighting%2C%20friendly%20expression%2C%20simple%20cream%20background%2C%20modern%20social%20media%20profile%20photo%2C%20natural%20look&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '八卦小能手',
    time: '32分钟前',
    content: '作为圈内人表示，这个爆料至少70%是真的。还有一些更猛的料还没放出来，坐等后续发展。51吃瓜在线这次速度可以啊，比别家快了不少。',
    likes: '2.8万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20stylish%20look%2C%20warm%20lighting%2C%20cheerful%20expression%2C%20simple%20cream%20background%2C%20modern%20social%20media%20profile%20photo%2C%20natural%20charming%20smile&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '理性吃瓜群众',
    time: '1小时前',
    content: '建议大家理性看待，先不要急着站队。目前双方各执一词，证据还不完整。不过51吃瓜在线的视频整理得很清晰，帮我们快速理清了时间线，这一点要给编辑点赞。',
    likes: '1.5万',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-bold mb-4">
            <i className="ri-chat-1-line"></i>
            瓜友热评
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            大家怎么说
          </h2>
          <p className="text-foreground-500 text-sm">精选热门评论，看看瓜友们都在讨论什么</p>
        </div>

        <div className="space-y-4">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 hover:shadow-sm transition-all duration-200">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full overflow-hidden bg-background-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-bold text-foreground-900">{c.name}</span>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    {c.content}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{c.likes}</span>
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-chat-3-line"></i>
                      <span>回复</span>
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-share-forward-line"></i>
                      <span>分享</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}